import type { ReflectionDetail as ReflectionDetailType } from '../types';

interface ReflectionDetailProps {
  reflection: ReflectionDetailType | null;
}

export function ReflectionDetail({ reflection }: ReflectionDetailProps) {
  if (!reflection) {
    return (
      <div className="h-full rounded-xl border border-dashed border-edge flex items-center justify-center text-ink-tertiary">
        Select a reflection to view details
      </div>
    );
  }

  return (
    <article className="h-full overflow-y-auto rounded-xl border border-edge bg-white p-4 glass-scroll">
      <header className="mb-3">
        <h2 className="text-lg font-bold text-ink">Weekly Reflection {reflection.week}</h2>
        <p className="text-xs text-ink-tertiary mt-1">
          Generated {new Date(reflection.generated_at).toLocaleString()}
        </p>
      </header>

      <section className="mb-4">
        <h3 className="text-sm font-semibold text-ink mb-2">Highlights</h3>
        <ul className="list-disc list-inside space-y-1 text-sm text-ink-secondary">
          {reflection.highlights.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="prose prose-sm max-w-none text-ink-secondary whitespace-pre-wrap">
        {reflection.content}
      </section>
    </article>
  );
}

export default ReflectionDetail;
